import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-business-uses',
  templateUrl: './business-uses.component.html',
})
export class BusinessUsesComponent {
  general: boolean = false;
  specific: boolean = false;
  source = "";
  blogs = [];
  loading: boolean = false;

  constructor(public router: Router, private httpService: HttpService, private activeRoute: ActivatedRoute) {
  
    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    console.log(this.source)

      this.fetchBlogs();
    
  


  }





  fetchBlogs() {

    this.loading = true;




    this.httpService.post<any>('Store/fetch-cabbagepay-smbuses', false).subscribe(
      resp => {
        this.blogs = JSON.parse(resp.message);

        //console.log(this.blogs);


        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }





}
